module.exports = {
	"id": "TW",
	"name": "Taiwan",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.061556,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": 0.005596,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": 0.011192,
			"28": 0.005596,
			"29": 0.02798,
			"30": 0.011192,
			"31": 0.033576,
			"32": 0.005596,
			"33": 0.134304,
			"34": 0.011192,
			"35": 0.016788,
			"36": 0.016788,
			"37": 0.016788,
			"38": 0.061556,
			"39": 0.078344,
			"40": 0.02798,
			"41": 0.02798,
			"42": 0.061556,
			"43": 0.1399,
			"44": 0.072748,
			"45": 0.190264,
			"46": 0.095132,
			"47": 0.128708,
			"48": 0.184668,
			"49": 2.507008,
			"50": 0.296588,
			"51": 0.884168,
			"52": 0.733076,
			"53": 24.807068,
			"54": 5.67994,
			"55": 0.050364,
			"56": 0.02798,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.011192,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": 0.011192,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": 0.005596,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": 0.011192,
			"34": 0.005596,
			"35": 0.011192,
			"36": 0.011192,
			"37": 0.005596,
			"38": 0.033576,
			"39": 0.011192,
			"40": 0.011192,
			"41": 0.022384,
			"42": 0.016788,
			"43": 0.089536,
			"44": 0.033576,
			"45": 0.072748,
			"46": 0.08394,
			"47": 0.346952,
			"48": 0.190264,
			"49": 2.999456,
			"50": 0.02798,
			"51": null,
			"52": null,
			"3.5": null,
			"3.6": null
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": 0.016788,
			"35": null,
			"36": 0.011192,
			"37": 0.033576,
			"38": 0.095132,
			"39": null,
			"40": 0.11192,
			"41": 0.016788,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.016788
		},
		"safari": {
			"0": null,
			"4": 0.022384,
			"5": 0.011192,
			"6": null,
			"7": 0.022384,
			"8": 0.11192,
			"9": 0.11192,
			"10": 0.710692,
			"3.1": null,
			"3.2": null,
			"5.1": 0.02798,
			"6.1": 0.022384,
			"7.1": 0.005596,
			"9.1": 0.50364
		},
		"ios_saf": {
			"8": 0,
			"10": 9.11390937885,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.245609311823,
			"8.1-8.4": 0.45375279642,
			"9.0-9.2": 0.21646922398,
			"9.3": 3.30254328893
		},
		"android": {
			"3": 0,
			"4": 0.0357587312661,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00446984140827,
			"4.1": 0.128986852067,
			"4.2-4.3": 0.322467130168,
			"4.4": 0.739439478682,
			"4.4.3-4.4.4": 0.745824966408
		},
		"ie": {
			"6": 0.0520428,
			"7": 0.0346952,
			"8": 1.3184176,
			"9": 0.439472533333,
			"10": 0.4163424,
			"11": 5.54544946667,
			"5.5": null
		},
		"op_mob": {
			"0": 0.0094129183359,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.000261469953775
		},
		"edge": {
			"12": 0.044768,
			"13": 0.414104,
			"14": 0.884168
		},
		"ie_mob": {
			"10": 0.0217049295775,
			"11": 0.0883700704225
		},
		"bb": {
			"7": 0,
			"10": null
		},
		"samsung": {
			"0": 3.051279
		},
		"and_uc": {
			"0": 0.17612
		},
		"op_mini": {
			"0": 0.12681861171
		},
		"and_chr": {
			"0": 28.711661
		},
		"and_ff": {
			"0": 0.022015
		}
	},
	"total": 98.944114
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/TW.json
 ** module id = 668
 ** module chunks = 0
 **/